export default "__VITE_ASSET__2e724b6f__"